import type { OpsPermissionsResponse } from '@nadoutong/contracts';
import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../hooks/useSession.tsx';
import { opsApiRequest } from './client.ts';

const OPS_PERMISSIONS_KEY = ['ops-permissions'] as const;

export async function getOpsPermissions(
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<OpsPermissionsResponse> {
  return opsApiRequest<OpsPermissionsResponse>(
    '/v1/ops/permissions',
    { signal },
    fetchImpl,
  );
}

export function useOpsPermissions(): UseQueryResult<OpsPermissionsResponse> {
  const { fetchImpl } = useSession();
  return useQuery({
    queryKey: OPS_PERMISSIONS_KEY,
    queryFn: ({ signal }) => getOpsPermissions(fetchImpl, signal),
  });
}
